import { InternalAxiosRequestConfig } from 'axios'
import { getClaimsJWT } from '../../feat/oauth/oauth.slice'
import { bs } from '../../state/bound.store'
import { Utils } from '../../utils'
export const authRequestInterceptor = async (
    request: InternalAxiosRequestConfig
) => {
    if (request.NO_AUTH === true) {
        return request
    }
    const token = Utils.getToken()

    if (token) {
        const refresh = await bs().refreshTokens()

        if (refresh.status === 'success') {
            request.headers['Authorization'] =
                'Bearer ' + (refresh.data?.access_token ?? '')
        } else {
            request.headers['Authorization'] = 'Bearer ' + token
        }
    }
    const claimToken = getClaimsJWT()
    if (claimToken && request && request.headers) {
        request.headers['X-Eventr-Claims'] = claimToken
    }
    return request
}
